import { ourGLPPlansImg } from "@/assets/images";
import { Button, ButtonType } from "@/components/common/button";
import { QuizQuestionProps } from "@/pages/quiz/context/types";

const OurGLPPlans = ({ setQuestionAnswer }: QuizQuestionProps<boolean>) => (
  <>
    <img
      src={ourGLPPlansImg}
      alt="Our GLP plans"
      className="mx-auto max-h-[400px] w-full"
    />

    <Button
      type={ButtonType.CONTINUE}
      onClick={() => setQuestionAnswer(true)}
    />
  </>
);

export { OurGLPPlans };
